// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3h9Fb","Inverted":"Button_Inverted__2nx87","MainColor":"Button_MainColor__1ggRN","DefaultColor":"Button_DefaultColor__3UuVu","Menu":"Button_Menu__1SVvY"};